import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

const primaryPalette = {
    50: 'color-mix(in srgb, var(--green-50) 90%, white)',
    100: 'color-mix(in srgb, var(--green-50) 75%, white)',
    200: 'color-mix(in srgb, var(--green-50) 55%, var(--green-300) 45%)',
    300: 'color-mix(in srgb, var(--green-50) 35%, var(--green-300) 65%)',
    400: 'color-mix(in srgb, var(--green-300) 40%, var(--green-400) 60%)',
    500: 'var(--green-300)',
    600: 'color-mix(in srgb, var(--green-300) 65%, var(--green-700) 35%)',
    700: 'var(--green-700)',
    800: 'color-mix(in srgb, var(--green-700) 85%, #000000 15%)',
    900: 'color-mix(in srgb, var(--green-700) 92%, #000000 8%)',
    950: 'color-mix(in srgb, var(--green-700) 96%, #000000 4%)'
};

export const CareAuditsPrimePreset = definePreset(Aura, {
    semantic: {
        primary: primaryPalette,
        focusRing: {
            color: 'color-mix(in srgb, var(--green-300) 50%, transparent)'
        },
        colorScheme: {
            light: {
                primary: {
                    color: 'var(--green-300)',
                    contrastColor: '#ffffff',
                    hoverColor: 'color-mix(in srgb, var(--green-300) 55%, var(--green-400) 45%)',
                    activeColor: 'var(--green-700)'
                },
                highlight: {
                    background: 'color-mix(in srgb, var(--green-50) 70%, white 30%)',
                    focusBackground: 'color-mix(in srgb, var(--green-50) 45%, var(--green-300) 55%)',
                    color: 'var(--green-700)',
                    focusColor: 'var(--green-700)'
                }
            },
            dark: {
                primary: {
                    color: 'var(--green-400)',
                    contrastColor: '#0b2930',
                    hoverColor: 'color-mix(in srgb, var(--green-400) 70%, var(--green-700) 30%)',
                    activeColor: 'var(--green-700)'
                },
                highlight: {
                    background: 'color-mix(in srgb, var(--green-300) 35%, transparent)',
                    focusBackground: 'color-mix(in srgb, var(--green-300) 50%, transparent)',
                    color: '#ffffff',
                    focusColor: '#ffffff'
                }
            }
        }
    }
});
